import { InfoType } from 'modules/Info/model/types'

export enum RouterPath {
  HOME = '/',
  CART = '/cart',
  PROFILE = '/profile',
  AUTH = '/auth',
  FAVORITES = '/favorites',
  DELIVERY = '/delivery',
  HELP = '/help',
  BUSINESS_MARKET = '/business-market',
  PRODUCT = '/product',
  CATALOG = '/catalog',
  CATEGORY = '/category',
  CATALOG_CATEGORY = '/catalog/category',
  CATALOG_SHOP = '/catalog/shop',
  SHOP = '/shop',
  ORDERS = '/profile/orders',
  ORDER_CREATE = '/cart/:id/create',
  SUPPORT = '/support',
  ADDRESSES = '/addresses',
}

// TODO: RouterPath перенести в ROUTER_PATHS
const createReturnRoute = () => ({
  path: '/returns/:id/:type',
  get: (id: string | number, type: string | number) => `/returns/${id}/${type}`,
})
export const ROUTER_PATHS = {
  home: '/',
  auth: '/auth',

  cart: '/cart',
  cartById: {
    path: '/cart/:id',
    get: (id: string | number) => `/cart/${id}/`,
  },

  orderCreate: {
    path: '/cart/:id/create',
    get: (cartId: string | number) => `/cart/${cartId}/create`,
  },

  // PRODUCT
  product: {
    path: '/product/:id',
    get: (id: string | number) => `/product/${id}`,
  },

  catalogShop: {
    path: '/catalog/shop/:id',
    get: (id: string | number) => `/catalog/shop/${id}`,
    getWithCategory: (id: string | number, categorySlug: string) =>
      `/catalog/shop/${id}?category=${categorySlug}`,
  },

  catalogBySearch: {
    path: '/catalog/?search',
    get: (search: string) => `/catalog?search=${search}`,
  },

  category: '/category',
  categoryById: {
    path: '/category/:id',
    get: (id: string | number) => `/category/${id}`,
    desktopGet: (id: string | number) => `/category/?categoryId=${id}`,
  },
  catalogCategoryById: {
    path: '/catalog/category/:id',
    get: (id: string | number) => `/catalog/category/${id}`,
    getWithShopId: (id: string | number, shopId: string | number) =>
      `/catalog/category/${id}?shopId=${shopId}`,
  },
  // Order
  orders: '/profile/orders',
  order: {
    path: '/profile/orders/:id',
    get: (id: string | number) => `/profile/orders/${id}`,
  },

  favorites: '/favorites',
  addresses: '/addresses',

  collection: {
    path: '/collections/',
    get: (id: string | number) => `/collections/${id}`,
  },

  service: '/service',

  info: {
    path: '/info',
    get: (type: InfoType) => `/info?infoType=${type}`,
  },

  profile: '/profile',
  shop: '/shop',
  search: {
    path: '/catalog/search/',
    get: (search: string) => `/catalog/search?search=${search}`,
    getWithAutoComplete: (search: string) =>
      `/catalog/search?search=${search}&autoComplete=true`,
  },
  // Returns
  returns: '/returns',
  returnById: {
    path: '/returns/:id',
    get: (id: string | number) => `/returns/${id}`,
  },
  returnsInit: createReturnRoute(),
  returnsCreate: createReturnRoute(),
  returnAppealingCreate: createReturnRoute(),
} as const
